import GetTiposNovedad from '@/modules/novedad/application/GetTiposNovedad'
import TipoNovedadApiRepository from '@/modules/novedad/infrastructure/TipoNovedadApiRepository'

export default {
  namespaced: true,

  state: {
    tiposNovedad: [],
  },

  getters: {
    getTiposNovedad: (state) => state.tiposNovedad,
  },

  mutations: {
    SET_TIPOS_NOVEDAD(state, tiposNovedad) {
      state.tiposNovedad = tiposNovedad
    },
  },

  actions: {
    async fetchTiposNovedad({ commit }) {
      try {
        const tiposNovedad = await new GetTiposNovedad(new TipoNovedadApiRepository()).execute()
        commit('SET_TIPOS_NOVEDAD', tiposNovedad)
      } catch (error) {
        commit('SET_SNACKBAR_MESSAGE', 'No fue posible obtener los tipos de novedad.', { root: true })
      }
    },
  },
}
